import React, { HTMLProps } from 'react';

import styles from './searchCurrencyItem.module.scss';

export interface SearchCurrencyItemProps extends HTMLProps<HTMLDivElement> {
  currency: string;
  code: string;
  isSelectedItem: boolean;
}

export const SearchCurrencyItem = ({ currency, code, isSelectedItem, ...divProps }: SearchCurrencyItemProps) => {
  return (
    <div {...divProps} className={isSelectedItem ? `${styles.container} ${styles.selected}` : styles.container}>
      <span className={styles.subtitle}>{code}</span>
      <span className={styles.title}>{currency}</span>
      {isSelectedItem && <span className={styles.tick}>&#x2713;</span>}
    </div>
  );
};
